import { createFileRoute, redirect } from '@tanstack/react-router'

/**
 * `/` always redirects into the admin shell. Auth-gating happens inside
 * the `/admin` segment (Phase 2 wires the platform-admin check that
 * bounces non-admins to a calm permission-denied state per HANDOFF §4
 * rule 8). Unauthenticated visitors get redirected to `/authentication/login`.
 */
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({ to: '/admin' })
  },
})
